(function () {
  function initMyocFooter() {
    document.querySelectorAll('.myoc-footer').forEach(function (footer) {
      const menus = footer.querySelectorAll('.myoc-footer__menu');

      menus.forEach(function (menu) {
        const btn = menu.querySelector('.myoc-footer__accordion-btn');

        if (!btn || btn.dataset.ready === 'true') return;

        btn.dataset.ready = 'true';

        btn.addEventListener('click', function () {
          if (window.innerWidth > 989) return;

          const isOpen = menu.classList.contains('is-open');

          menus.forEach(function (item) {
            item.classList.remove('is-open');
            const itemBtn = item.querySelector('.myoc-footer__accordion-btn');
            if (itemBtn) itemBtn.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            menu.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initMyocFooter);
  document.addEventListener('shopify:section:load', initMyocFooter);
})();